<template>
  <div>

    <!-- Adicionar novo -->
    <cliente-list-add-new
      :is-add-new-cliente-sidebar-active.sync="isAddNewClienteSidebarActive"
      :situacao-options="situacaoOptions"
      :tipo-pessoa-options="tipoPessoaOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <cliente-list-filters
      :situacao-filter.sync="situacaoFilter"
      :situacao-options="situacaoOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="9"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Procurar..."
                debounce="600"
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewClienteSidebarActive = true"
              >
                <span class="text-nowrap">Adicionar Devedor</span>
              </b-button> -->
              <b-button
                variant="outline-success"
                class="ml-1"
                v-b-modal.modal-import
              >
                <span class="text-nowrap">Importar Planilha</span>
              </b-button>

              <!-- modal import-->
              <b-modal
                id="modal-import"
                cancel-variant="outline-danger"
                ok-title="Importar"
                cancel-title="Fechar"
                centered
                title="Importar planilha de devedores"
                @ok="submitImport"
              >
                <b-form>
                  <b-form-group>
                    <label for="email">Arquivo:</label>
                    <b-form-file
                      ref="file"
                      v-model="fileImport"
                      placeholder="Escolha um arquivo..."
                      drop-placeholder="Arraste um arquivo aqui..."
                      accept=".xlsx, .xls"
                    />

                    <b-card-text class="my-1">
                      Arquivo selecionado: <strong>{{ fileImport ? fileImport.name : '' }}</strong>
                    </b-card-text>
                  </b-form-group>
                </b-form>
              </b-modal>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refClienteListTable"
        class="position-relative"
        responsive
        striped
        hover
        :items="fetchClientes"
        :fields="tableColumns"  
        primary-key="id"
        show-empty
        empty-text="Nenhum registro encontrado"
      >
        <!-- Column: User -->
        <template #cell(nome)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.nome)"
                variant="light-danger"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap" 
            >
              {{ data.item.nome }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Status -->
        <template #cell(situacao)="data">
          <b-badge
            pill
            :variant="`light-${resolveClienteStatusVariant(data.item.situacao)}`"
            class="text-capitalize"
          >
            {{ data.item.situacao }}
          </b-badge>
        </template>

        <!-- Column: Credor -->
        <template #cell(credor)="data">
          <span class="font-weight-bolder">{{ data.item.credor }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>      
            <b-dropdown-item :to="{ path: '/devedores/editar/'+data.item.id }" target="_blank"> 
              <div>
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Editar</span>
              </div>
            </b-dropdown-item>     

            <b-dropdown-item>
              <div @click="showModalDelete(data.item.id)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Excluir</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo de {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.total }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="dataMeta.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,BModal,BFormFile, BForm, BFormGroup, BCardText 
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, computed} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ClienteListFilters from './ClienteListFilters.vue'
import ClienteListAddNew from './ClienteListAddNew.vue'
import useClienteList from './useClienteList'
import clienteStoreModule from '../clienteStoreModule'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import { useRouter } from '@core/utils/utils'

export default {
  components: {
    ClienteListFilters,
    ClienteListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    BFormFile,
    BForm,
    BFormGroup,
    BCardText,

    vSelect,
  },
  setup() {
    const CLIENTE_APP_STORE_MODULE_NAME = 'app-cliente'

    // Register module
    if (!store.hasModule(CLIENTE_APP_STORE_MODULE_NAME)) store.registerModule(CLIENTE_APP_STORE_MODULE_NAME, clienteStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CLIENTE_APP_STORE_MODULE_NAME)) store.unregisterModule(CLIENTE_APP_STORE_MODULE_NAME)
    })

    const isAddNewClienteSidebarActive = ref(false)

    const fileImport = ref(null)

    const { route } = useRouter()
    const credorId = computed(() => route.value.query.credorId)

    function submitImport(){
      if(this.fileImport == null){
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Importação Devedores',
              icon: 'FileIcon',
              variant: 'danger',
              text: `Por favor, selecione um arquivo.`,
            },
          })
      }else{
        const file = this.$refs.file.files[0]
        let formData = new FormData();

        formData.append('devedores', file);
        axios.post('importar/devedores',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((response) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Importação Devedores',
              icon: 'FileIcon',
              variant: 'success',
              text: `Tudo certo, sua importação está sendo processada!`,
            },
          })
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Importação Devedores',
              icon: 'FileIcon',
              variant: 'danger',
              text: `Algo deu errado com seu arquivo ):`,
            },
          })
        });

        this.fileImport = null
      }
    }

    function showModalDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Você deseja prosseguir com a exclusão?', {
          title: 'Confirme sua ação',
          size: 'sm',
          modalClass: 'modal-danger',
          okVariant: 'danger',
          okTitle: 'Sim, confirmar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value == true){
            axios.delete('clientes/'+id)
            .then((response) => {
              this.$refs.refClienteListTable.refresh();
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Exclusão de registro',
                  icon: 'FileIcon',
                  variant: 'success',
                  text: `Devedor excluído com sucesso!`,
                },
              })
            }).catch(error => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Exclusão de registro',
                  icon: 'FileIcon',
                  variant: 'danger',
                  text: `Não foi possível excluir seu devedor ):`,
                },
              })
            });
          }
        })
    }

    const situacaoOptions = [
      { label: 'Ativo', value: 'ATIVO' },
      { label: 'Inativo', value: 'INATIVO' }
    ]

    const tipoPessoaOptions = [
      { label: 'Pessoa Física', value: 'PF' },
      { label: 'Pessoa Jurídica', value: 'PJ' }
    ]

    const {
      fetchClientes,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refClienteListTable,
      refetchData,

      // UI
      resolveClienteStatusVariant,

      // Extra Filters
      situacaoFilter,
      tipoPessoaFilter
    } = useClienteList(credorId)

    return {

      // Sidebar
      isAddNewClienteSidebarActive,

      fetchClientes,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refClienteListTable,
      refetchData,

      // Filter
      avatarText,
    

      // UI
      resolveClienteStatusVariant,

      situacaoOptions,
      tipoPessoaOptions,

      // Extra Filters
      situacaoFilter,
      tipoPessoaFilter,
      credorId,
       
      fileImport,
      submitImport,
      showModalDelete
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
